import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { FolderOpen } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const VerExpDrive = ({ lid }) => {
  const nav = useNavigate();
  const [d, setD] = useState(undefined);
  useEffect(() => { http.get("/expedientes-drive/credito/carpeta", { params: { loan: lid } }).then((r) => setD(r.data)).catch(() => setD({})); }, [lid]);
  if (d === undefined) return null;
  const abrir = (id) => nav(`/cartera/expedientes?carpeta=${encodeURIComponent(id)}`);
  if (d.carpeta) return (
    <Link to={`/cartera/expedientes?carpeta=${encodeURIComponent(d.carpeta.id)}`} className="inline-flex items-center gap-1.5 rounded-full border border-[#1F2A44] px-3 py-1 text-xs font-semibold text-[#1F2A44] transition-colors hover:bg-[#1F2A44] hover:text-white" data-testid="loan-ver-expediente-drive">
      <FolderOpen className="h-3.5 w-3.5" />Ver expediente (Sistema)
    </Link>
  );
  if (d.sugerida) {
    const s = d.sugerida;
    const confirmar = () => http.post(`/expedientes-drive/clientes/${s.id}/mapeo`, { loans: s.loans }).then(() => { toast.success("Carpeta confirmada"); abrir(s.id); }).catch((e) => toast.error(errMsg(e)));
    return (
      <span className="inline-flex flex-wrap items-center gap-2 rounded-full border border-dashed border-[#B98A2E] px-3 py-1 text-xs text-[#5C5850]" data-testid="loan-carpeta-sugerida">
        Carpeta sugerida: <b className="max-w-[16rem] truncate">{s.nombre}</b>
        <button onClick={confirmar} className="font-semibold text-[#1F2A44] underline" data-testid="loan-confirmar-carpeta">Confirmar</button>
      </span>
    );
  }
  return <span className="inline-flex items-center rounded-full border border-[#E2DDD5] px-3 py-1 text-xs text-[#8C867A]" data-testid="loan-sin-carpeta">Sin carpeta en el Sistema</span>;
};
